var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-item__container"},[_c('p',{staticClass:"paragraph__heading"},[_vm._v(_vm._s(_vm.data.heading))]),_c('p',{staticClass:"grid-item__content"},[_vm._v(_vm._s(_vm.data.content))]),(_vm.has_arrow_down)?_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":['fas', 'angle-double-down']}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }